export default "__VITE_ASSET__$rSd0G9I__"